export const OVERALL_CHART_TITLE = "Overall Performance Trend";
export const EXPECTATIONS_CHART_TITLE = "Expectations Trend";
export const WARMTH_CHART_TITLE = "Warmth Trend";



// WEBPACK FOOTER //
// ./src/pages/director/SurveyDataCenter/components/SurveyCharts/constants.ts